import { joinCn } from '../util';
import type { BASE_TOGGLE_BUTTON_SIZE } from './constant';

const style = {
  baseToggleButton(size: Lowercase<keyof typeof BASE_TOGGLE_BUTTON_SIZE>) {
    return joinCn(
      'flex items-center justify-center px-2 py-1',
      {
        'rounded-md': size === 'md',
        'rounded-sm': size === 'sm',
      },
      'border',

      'enabled:hover:shadow-sm',
    );
  },
  pressedToggleButton(size: Lowercase<keyof typeof BASE_TOGGLE_BUTTON_SIZE>) {
    return joinCn(
      'gap-1',
      {
        'text-body-l font-bold': size === 'md',
        'text-body-s font-semibold': size === 'sm',
      },
      'text-secondary-300',
      'border-secondary-300',

      'disabled:border-gray-200 disabled:bg-gray-200',
    );
  },
  normarToggleButton(size: Lowercase<keyof typeof BASE_TOGGLE_BUTTON_SIZE>) {
    return joinCn(
      'text-black',
      {
        'text-body-l': size === 'md',
        'text-body-s': size === 'sm',
      },
      'bg-white',
      'border-gray-300',

      'enabled:hover:border-secondary-300',

      'disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-400',
    );
  },
  filterChip(
    isSelected: boolean = false,
    size: Lowercase<keyof typeof BASE_TOGGLE_BUTTON_SIZE>,
  ) {
    return joinCn(
      this.baseToggleButton(size),
      isSelected
        ? this.pressedToggleButton(size)
        : this.normarToggleButton(size),
    );
  },

  icon(size: Lowercase<keyof typeof BASE_TOGGLE_BUTTON_SIZE>) {
    return size === 'md' ? 'h-6 w-6' : 'h-4 w-4';
  },
  text: joinCn('translate-y-0.25'),
};

export default style;
